import { IAppState } from '../types';

export const getChatLoaded = (state: IAppState): boolean => state.chat.loaded;
